import React, { useContext, useEffect, useState, useRef } from 'react'
import ThreeSixtyIcon from '../../../partials/assets/360Icon.svg'
import Magic360Spinner from './Magic360Spinner'
import { Translations } from '../services/TranslationService'
import { getBrightcovePlayerInfo, getBrightcoveVideoImage } from '../services/UtilityService'
import {
    MAGIC360_CODE,
    MAIN_IMAGE_CODE,
    ADDITIONAL_IMAGE_CODE,
    VIDEO_CODE,
    POLICY_KEY
} from '../constants/PDPConstants'

const videoThumbnailCache = new Map();

const Thumbnail = ({
    mediaElement,
    magic360media,
    showMore,
    showMoreLabel,
    isMainImage,
    isInnerGallery,
    index
}) => {
    const translations = useContext(Translations)
    const [videoThumbnail, setVideoThumbnail] = useState(
        'https://www.3m.com/3m_theme_assets/themes/3MTheme/assets/images/lazy-preloader-clear.gif'
    )

    useEffect(() => {
        if (mediaElement?.usageCode === VIDEO_CODE) {
            const brightcoveInfo = getBrightcovePlayerInfo(mediaElement?.videoPlayerId);

            const loadThumbnail = async () => {
                if (videoThumbnailCache.has(mediaElement.videoPlayerId)) {
                    setVideoThumbnail(videoThumbnailCache.get(mediaElement.videoPlayerId));
                    return;
                }

                const data = await getBrightcoveVideoImage(
                    brightcoveInfo.dataAccountId,
                    mediaElement?.videoPlayerListId,
                    POLICY_KEY,
                    mediaElement?.videoPlayerType
                );

                let poster = null

                mediaElement?.videoPlayerType?.toLowerCase() === 'single'
                    ? (poster = data?.poster)
                    : (poster = data?.videos?.[0]?.poster);

                const finalPoster =
                    poster ||
                    'https://www.3m.com/3m_theme_assets/themes/3MTheme/assets/images/lazy-preloader-clear.gif';

                videoThumbnailCache.set(mediaElement.videoPlayerId, finalPoster);
                setVideoThumbnail(finalPoster);
            };

            loadThumbnail();
        }
    }, [mediaElement]);

    return (
        <>
            {/* Images */}
            {(mediaElement?.usageCode === ADDITIONAL_IMAGE_CODE ||
                mediaElement?.usageCode === MAIN_IMAGE_CODE) && (
                <>
                    {showMore && <span>{showMoreLabel}</span>}
                    <img
                        src={`${mediaElement?.url}${isMainImage ? '?width=506' : ''}`}
                        alt={mediaElement?.altText}
                        loading="lazy"
                    ></img>
                </>
            )}
            {/* Videos */}
            {mediaElement?.usageCode === VIDEO_CODE && (
                <>
                    {showMore && <span>{showMoreLabel}</span>}
                    <div className="bc-thumbnail-container">
                        <img src={videoThumbnail} alt="video-thumbnail" />
                        <span
                            className="MMM--icn MMM--icn_arrowRight"
                            aria-hidden="true"
                        ></span>
                    </div>
                </>
            )}
            {/* 360 Spinners */}
            {mediaElement?.usageCode === MAGIC360_CODE && isInnerGallery && (
                <div className="sps2-pdp_gallery--magiczoom-inner">
                    <Magic360Spinner
                        altText={mediaElement?.altText}
                        magic360={magic360media?.find(
                            (element) => element.position === index
                        )}
                    />
                    <div className="sps2-pdp_gallery--hoverText sps2-pdp_gallery--hoverText-inner">
                        {`${translations.dragSpin} | ${translations.clickTapZoom}`}
                    </div>
                </div>
            )}
            {mediaElement?.usageCode === MAGIC360_CODE && !isInnerGallery && (
                <>
                    <div className="sps2-pdp_gallery--list-360icon">
                        <ThreeSixtyIcon
                            style={{ width: `${isMainImage ? '120px' : '40px'}` }}
                        />
                    </div>
                    {showMore && <span>{showMoreLabel}</span>}
                    <img
                        src={
                            magic360media?.find((element) => element.position === index)
                                ?.firstfileurl
                        }
                        alt={mediaElement?.altText}
                        loading="lazy"
                    ></img>
                </>
            )}
        </>
    )
}

Thumbnail.defaultProps = {
    showMore: false,
    isMainImage: false
}

export default Thumbnail
